import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class MathService{
    public roundTo2DecimalPlaces(value: number) {
        return Math.round( ( value + 0.000001) * 100 ) / 100;
    }
}
